import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './highest-level-of-qualification.reducer';

export const HighestLevelOfQualificationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const highestLevelOfQualificationEntity = useAppSelector(state => state.highestLevelOfQualification.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="highestLevelOfQualificationDetailsHeading">
          <Translate contentKey="apiLocationApp.highestLevelOfQualification.detail.title">HighestLevelOfQualification</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{highestLevelOfQualificationEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.highestLevelOfQualification.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{highestLevelOfQualificationEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.highestLevelOfQualification.date">Date</Translate>
            </span>
          </dt>
          <dd>{highestLevelOfQualificationEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.highestLevelOfQualification.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{highestLevelOfQualificationEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.highestLevelOfQualification.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{highestLevelOfQualificationEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllUsualResidents">
              <Translate contentKey="apiLocationApp.highestLevelOfQualification.totalAllUsualResidents">
                Total All Usual Residents
              </Translate>
            </span>
          </dt>
          <dd>{highestLevelOfQualificationEntity.totalAllUsualResidents}</dd>
          <dt>
            <span id="noQualifications">
              <Translate contentKey="apiLocationApp.highestLevelOfQualification.noQualifications">No Qualifications</Translate>
            </span>
          </dt>
          <dd>{highestLevelOfQualificationEntity.noQualifications}</dd>
          <dt>
            <span id="level1Qualifications">
              <Translate contentKey="apiLocationApp.highestLevelOfQualification.level1Qualifications">Level 1 Qualifications</Translate>
            </span>
          </dt>
          <dd>{highestLevelOfQualificationEntity.level1Qualifications}</dd>
          <dt>
            <span id="level2Qualifications">
              <Translate contentKey="apiLocationApp.highestLevelOfQualification.level2Qualifications">Level 2 Qualifications</Translate>
            </span>
          </dt>
          <dd>{highestLevelOfQualificationEntity.level2Qualifications}</dd>
          <dt>
            <span id="apprenticeship">
              <Translate contentKey="apiLocationApp.highestLevelOfQualification.apprenticeship">Apprenticeship</Translate>
            </span>
          </dt>
          <dd>{highestLevelOfQualificationEntity.apprenticeship}</dd>
          <dt>
            <span id="level3Qualifications">
              <Translate contentKey="apiLocationApp.highestLevelOfQualification.level3Qualifications">Level 3 Qualifications</Translate>
            </span>
          </dt>
          <dd>{highestLevelOfQualificationEntity.level3Qualifications}</dd>
          <dt>
            <span id="level4QualificationsAndAbove">
              <Translate contentKey="apiLocationApp.highestLevelOfQualification.level4QualificationsAndAbove">
                Level 4 Qualifications And Above
              </Translate>
            </span>
          </dt>
          <dd>{highestLevelOfQualificationEntity.level4QualificationsAndAbove}</dd>
          <dt>
            <span id="otherQualifications">
              <Translate contentKey="apiLocationApp.highestLevelOfQualification.otherQualifications">Other Qualifications</Translate>
            </span>
          </dt>
          <dd>{highestLevelOfQualificationEntity.otherQualifications}</dd>
        </dl>
        <Button tag={Link} to="/highest-level-of-qualification" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/highest-level-of-qualification/${highestLevelOfQualificationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HighestLevelOfQualificationDetail;
